import { Link } from "react-router-dom";

export default function LegalLayout({ title, updated, children }) {
  return (
    <section className="bg-white min-h-[calc(100vh-5rem)]">
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-20 md:py-28">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B4513]">Legal</span>
        <h1 className="font-heading text-4xl md:text-6xl font-black tracking-tight mt-4">{title}</h1>
        <p className="mt-4 text-sm text-[#8B7A70]">Last updated: {updated}</p>
        <div className="mt-10 space-y-6 text-[#594A42] leading-relaxed legal-body">
          {children}
        </div>
        <p className="mt-14 pt-8 border-t border-[#E5E1DE] text-sm text-[#8B7A70]">
          Questions about this policy?{" "}
          <Link to="/contact" className="text-[#00B4C4] font-medium">Send us a message</Link>.
        </p>
      </div>
    </section>
  );
}
